import { createFileRoute } from '@tanstack/react-router';
import { FreezesPage } from '../../../features/freeze/freezes-page.tsx';
import { guardSection } from '../../../shell/guard.ts';

// Owner admin: evidence freezes (T32).
export const Route = createFileRoute('/_authed/admin/freezes')({
  beforeLoad: guardSection('/admin'),
  component: FreezesPage,
});
